/* CliniEco · 失禁用品月度用量与成本测算器
 * 数据源＝deliverables/2026-10/失禁测算页_构建数据源v1.0_20261003.md（Admin API 实读，2026-10-03）
 * 🔴 改价格必须同步改这里的 PRICE/PACK 与数据源文档，两处逐字一致（页面价格由 GEO 逐条回读比对）
 * 红线：无表单/无邮箱门 · 无时效词 · 无疗效词 · 不手写 hreflang
 */
(function () {
  'use strict';

  // ── 线上真值（Admin API 实读；售价 CAD，不含税与运费）──────────────
  var ITEMS = [
    { id: 'up3036',   label: 'Disposable Underpads 30×36 in (heavy)',      price: 51.96,  pack: 200, unit: 'pads',   unitCost: 0.260 },
    { id: 'uppla',    label: 'PLA Biodegradable Underpads 30×36 in',       price: 39.99,  pack: 50,  unit: 'pads',   unitCost: 0.800 },
    { id: 'up6090',   label: 'Underpads 60×90 cm (5-layer, SAP)',          price: 239.99, pack: 500, unit: 'pads',   unitCost: 0.480 },
    { id: 'pullon',   label: 'Adult Pull-On Briefs — Maximum',             price: 94.80,  pack: 120, unit: 'briefs', unitCost: 0.790 },
    { id: 'daypro',   label: 'Day Pro Adult Briefs',                       price: 94.80,  pack: 120, unit: 'briefs', unitCost: 0.790 },
    { id: 'nightplus',label: 'Night Plus Adult Briefs (overnight)',        price: 120.00, pack: 120, unit: 'briefs', unitCost: 1.000 }
  ];

  var LEVELS = { light: 2, moderate: 4, heavy: 6 };   // 规划假设，可被用户覆盖
  var DAYS_DEFAULT = 30;

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function num(v, d) { var x = parseFloat(v); return isFinite(x) && x > 0 ? x : d; }

  // ── 纯函数：便于自检（test_calc 用同一实现）──────────────────────
  function compute(residents, perDay, days, item) {
    var usage = residents * perDay * days;                 // 月用量（片）
    var cases = Math.ceil(usage / item.pack);              // 整包/整箱向上取整
    var cost = cases * item.price;                          // 月成本（CAD）
    var perResident = cost / residents;
    return { usage: Math.round(usage), cases: cases,
             billedUnits: cases * item.pack,
             cost: cost, perResident: perResident };
  }

  function byId(id) { for (var i = 0; i < ITEMS.length; i++) if (ITEMS[i].id === id) return ITEMS[i]; return ITEMS[0]; }

  function render() {
    var root = document.getElementById('cli-inc-planner');
    if (!root) return;
    var residents = num((document.getElementById('cli-inc-residents') || {}).value, 0);
    var perDay = num((document.getElementById('cli-inc-perday') || {}).value, 0);
    var days = num((document.getElementById('cli-inc-days') || {}).value, DAYS_DEFAULT);
    var item = byId((document.getElementById('cli-inc-item') || {}).value);
    var out = document.getElementById('cli-inc-out');
    if (!out) return;
    if (!residents || !perDay) {
      out.innerHTML = '<p class="cli-inc-hint">Enter the number of residents and the daily change count to see the estimate.</p>';
      return;
    }
    var r = compute(residents, perDay, days, item);
    out.innerHTML =
      '<table class="cli-inc-table"><tbody>' +
      '<tr><th>Residents</th><td>' + residents + '</td></tr>' +
      '<tr><th>Changes per day (per resident)</th><td>' + perDay + '</td></tr>' +
      '<tr><th>Days per month</th><td>' + days + '</td></tr>' +
      '<tr><th>Monthly units needed</th><td><strong>' + r.usage.toLocaleString() + ' ' + item.unit + '</strong></td></tr>' +
      '<tr><th>Order in whole packs/cases</th><td>' + r.cases + ' × pack (' + r.billedUnits.toLocaleString() + ' ' + item.unit + ') @ ' + money(item.price) + '</td></tr>' +
      '<tr><th>Monthly cost (CAD, before tax &amp; shipping)</th><td><strong>' + money(r.cost) + '</strong></td></tr>' +
      '<tr><th>Per resident / per month</th><td><strong>' + money(r.perResident) + '</strong></td></tr>' +
      '</tbody></table>' +
      '<p class="cli-inc-note">Estimates use planning assumptions, not clinical advice. Purchase is in whole packs/cases. ' +
      'Prices are our website retail prices in CAD and exclude tax and shipping.</p>';
  }

  function init() {
    var root = document.getElementById('cli-inc-planner');
    if (!root) return;
    var lv = document.getElementById('cli-inc-level');
    if (lv) lv.addEventListener('change', function () {
      var pd = document.getElementById('cli-inc-perday');
      if (pd && LEVELS[lv.value]) pd.value = LEVELS[lv.value];
      render();
    });
    ['cli-inc-residents', 'cli-inc-perday', 'cli-inc-days', 'cli-inc-item'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', render);
      if (el) el.addEventListener('change', render);
    });
    var pr = document.getElementById('cli-inc-print');
    if (pr) pr.addEventListener('click', function () { window.print(); });
    render();
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }
  // 供离线自检（Node）取用同一实现
  if (typeof module !== 'undefined' && module.exports) module.exports = { compute: compute, ITEMS: ITEMS, LEVELS: LEVELS };
})();
